import { Component } from "@angular/core";
import { ConfirmationDialogComponent } from "@common/ux/adapt-common-dialog/confirmation-dialog.component/confirmation-dialog.component";

@Component({
    selector: "adapt-workflow-confirm-dialog",
    templateUrl: "./workflow-confirm-dialog.component.html",
    styleUrl: "./workflow-confirm-dialog.component.css",
    standalone: false,
})
export class WorkflowConfirmDialogComponent extends ConfirmationDialogComponent { }
